import { useState } from "react";
import axios from "../../../lib/axios";
import { convertOrderStatusEnumToStatusCode } from "../../../utils/convertOrderStatusValue";
import { OrderStatusEnum } from "../../../enums/orderStatus";
import {
  ADMIN_ORDER_UPDATE,
  ADMIN_ORDER_UPDATE_STATUS,
} from "../../../lib/endpoints/order";
import { OrderModel } from "../../../models/order";
import { CartsModel } from "../../../models/carts";
import { useTranslation } from "react-i18next";

interface Props {
  selectedData: OrderModel;
  onClose: VoidFunction;
  onRefetchData: () => Promise<void>;
  currentCarts: CartsModel[];
  oriCarts: CartsModel[];
}

const useReadyToShipController = ({
  selectedData,
  onClose,
  onRefetchData,
  currentCarts,
  oriCarts,
}: Props) => {
  const [loadingConfirmDialog, setLoadingConfirmDialog] =
    useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const { t } = useTranslation("global");

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleAcceptOrder = async () => {
    try {
      setLoadingConfirmDialog(true);
      const newCart = currentCarts?.map((item) => {
        return {
          productId: item?.product?.id,
          quantity: item?.quantity,
        };
      });
      const oldCart = selectedData?.carts?.map((item) => {
        return {
          productId: item?.product?.id,
          quantity: item?.quantity,
        };
      });
      const input: any = {
        carts: newCart,
        paymentMethod: selectedData?.paymentMethod,
        orderMethod:selectedData?.orderMethod
      };

      if (selectedData?.couponCode) {
        input.couponCode = selectedData?.couponCode;
      }
      if (selectedData?.address?.id) {
        input.addressId = selectedData?.address?.id;
      }
      if (JSON.stringify(newCart) !== JSON.stringify(oldCart)) {
        await axios.post(
          `${ADMIN_ORDER_UPDATE}?id=${
            selectedData?.id
          }&status=${convertOrderStatusEnumToStatusCode(
            OrderStatusEnum.To_Ship
          )}`,
          input
        );
      } else {
        await axios.post(
          `${ADMIN_ORDER_UPDATE_STATUS}?orderId=${
            selectedData?.id
          }&status=${convertOrderStatusEnumToStatusCode(
            OrderStatusEnum.To_Ship
          )}`
        );
      }

      await onRefetchData();
      onClose();
    } catch (error: any) {
      try {
        console.log(error);
        if (error?.response?.data?.statusCode === 400) {
          window.alert("ການແພັກເຄື່ອງຈາກ SBC ບໍ່ສຳເລັດ");
        } else {
          const getErrorMessage: string = error.response.data.message;
          window.alert(getErrorMessage);
        }
      } catch (err) {
        window.alert(t("Server error please try again") || "");
      }
    } finally {
      setLoadingConfirmDialog(false);
    }
  };
  return {
    handleAcceptOrder,
    loadingConfirmDialog,
    handleOpenConfirmDialog,
    handleCloseConfirmDialog,
    openConfirmDialog,
  };
};
export default useReadyToShipController;
